var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner',{attrs:{"banner":_vm.response.banner}}),_c('Intro',{attrs:{"title":_vm.response.intro.title,"text":_vm.response.intro.text,"width":"845px"}}),_c('InvestmentsListing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }